import bornToDie from './bornToDie.json';
import comeAroundSundown from './comeAroundSundown.json';
import exRe from './exRe.json';
import extraordinaryMachine from './extraordinaryMachine.json';
import manOnTheMoon2 from './manOnTheMoon2.json';
import seaOfCowards from './seaOfCowards.json';
import swimming from './swimming.json';
import whenWeAllFallAsleep from './whenWeAllFallAsleep.json';
import wishYouWereHere from './wishYouWereHere.json';

export default {
  'Born To Die': bornToDie,
  'Come Around Sundown': comeAroundSundown,
  'Ex:Re': exRe,
  'Extraordinary Machine': extraordinaryMachine,
  'Man On The Moon II: The Legend of Mr. Rager': manOnTheMoon2,
  'Sea Of Cowards': seaOfCowards,
  Swimming: swimming,
  'WHEN WE ALL FALL ASLEEP, WHERE DO WE GO?': whenWeAllFallAsleep,
  'Wish You Were Here': wishYouWereHere
};
